import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Paywall from "@/components/Paywall";

const ProtectedRoute = ({ children, requirePremium = false, feature }) => {
  const { user, access, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="flex items-center gap-2 text-neutral-500">
          <div className="typing-dot" />
          <div className="typing-dot" />
          <div className="typing-dot" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePremium && access && !access.has_access) {
    return <Paywall feature={feature} />;
  }
  return children;
};

export default ProtectedRoute;
